import FacilityItem from "@/components/FacilityItem";

import { FacilidadeType } from "@/types/facilities";

import styles from "./styles.module.scss";

export type FacilitiesListProps = {
  title: string;
  label?: string;
  id: string;
  facilidades: FacilidadeType[];
  divider?: boolean;
};

const FacilitiesList = ({
  title,
  label,
  id,
  facilidades,
  divider = false
}: FacilitiesListProps) => {
  return (
    <div className={styles.wrapper}>
      <h3 className={`subtitle-lg ${!label && styles.mb}`}>{title}</h3>
      {label && <p className={`body-text-sm ${styles.mb}`}>{label}</p>}
      <ul>
        {facilidades.map(
          ({ group, name, subtitle, icon }: FacilidadeType, index: number) => {
            if (group === id) {
              return (
                <li key={index}>
                  <FacilityItem
                    name={name}
                    subtitle={subtitle}
                    icon={icon}
                    group={group}
                  />
                </li>
              );
            }
          }
        )}
      </ul>
      {divider && <hr className="divider" />}
    </div>
  );
};

export default FacilitiesList;
